export default {
  index: '/',
  dashboard: '/dashboard',
  login: '/login',
  changePassword: '/change-password',
  customerForceAction: '/customer-force',
  resetPassword: '/reset-password',
  forgotPassword: '/forgot-password',
  transfer: '/transfers',
  beneficiaries: '/beneficiaries',
  pendingRequests: '/pendingRequests',
  fxTransferRates: '/fxTransferRate',
  mobileMoney: '/mobileMoney',
  faq: '/faq',
  help: '/help',
  complaint: '/complaint',
  contactUs: '/contact-us',
  privacyPolicy: '/privacy-policy',
  regulatoryDirectives: '/regulatory-directives',
  billPayments: '/billPayments',
  myRequests: '/myRequests',
  prepaidCardLoad: '/prepaidCardLoad',
  bankStatement: '/bankStatements',
  scheduleTransfers: '/scheduleTransfers',
  transactionReport: '/transactionReports',
};
